module.exports = __webpack_public_path__ + "static/media/logout.39526e44.png";